'use strict';

(function () {
  'use strict';

  angular.module('msSleep').component('msInitialSleepSchedule', {
    templateUrl: 'sleep/templates/components/initial-sleep-schedule.html',
    controller: InitialSleepSchedule,
    controllerAs: 'vm',
    bindings: {
      schedule: '<',
      /* <object> encapsulates average sleep times returned from getEntries */
      onComplete: '&'
      /* <function> callback that takes user to next page */
    }
  });

  InitialSleepSchedule.$inject = ['$log', 'sleepScheduleSvc', 'msSmoothScroll', 'eventTrackingSvc'];

  function InitialSleepSchedule($log, sleepScheduleSvc, msSmoothScroll, eventTrackingSvc) {
    var vm = this;
    vm.stepIndex = 0;
    vm.errorMinutes = sleepScheduleSvc.ERROR_THRESHOLD;
    vm.warningMinutes = sleepScheduleSvc.WARNING_THRESHOLD;
    vm.sleepBuffer = sleepScheduleSvc.SLEEP_BUFFER;
    vm.getDifferenceInMinutes = sleepScheduleSvc.getDifferenceInMinutes;

    vm.changeRiseTime = function (amount) {
      vm.schedule.wakeUpTime.add(amount, 'minutes');
      vm.schedule.inBedTime.add(amount, 'minutes');
      // sync the recommended in-bed time with wake time in this scenario 
      vm.recommendedInBedTime = moment(vm.schedule.inBedTime);
    };

    vm.changeInBedTime = function (amount) {
      vm.noticeClosed = false;
      vm.schedule.inBedTime = moment(vm.schedule.inBedTime).add(amount, 'minutes');
      vm.minutesInBed -= amount;
    };

    vm.changeWakeUpTime = function (amount) {
      vm.noticeClosed = false;
      vm.schedule.wakeUpTime.add(amount, 'minutes');
      vm.minutesInBed += amount;
    };

    vm.complete = function () {
      eventTrackingSvc.fireEvent('sleepTool', 'scheduleSaved', 'create');
      vm.schedule.inBedTime = sleepScheduleSvc.saveSchedule({
        recommendedMinutesInBed: vm.recommendedMinutesInBed,
        inBedTime: vm.schedule.inBedTime.format('HH:mm:ss.SSSSSSSSS'),
        wakeUpTime: vm.schedule.wakeUpTime.format('HH:mm:ss.SSSSSSSSS')
      }).then(function () {
        if (_.isFunction(vm.onComplete)) {
          vm.onComplete();
        }
      });
    };

    vm.jumpToNext = function () {
      if (vm.stepIndex === 6) {
        // accept whatever was chosen as rise time as the new recommendation
        vm.recommendedWakeUpTime = moment(vm.schedule.wakeUpTime);
      }
      vm.stepIndex++;
      msSmoothScroll.scrollToEl('body', '#checkin' + (vm.stepIndex - 1), 0, -80, true);
      vm.noticeClosed = true;
    };

    vm.displayHour = function (minutes) {
      return Math.floor(minutes / 60);
    };

    vm.displayMinute = function (minutes) {
      return minutes % 60;
    };

    vm.isScheduleWarning = function () {
      return vm.minutesInBed >= vm.recommendedMinutesInBed + vm.warningMinutes || vm.minutesInBed <= vm.recommendedMinutesInBed - vm.warningMinutes;
    };

    vm.isScheduleError = function () {
      return vm.minutesInBed >= vm.maximumMinutesInBed || (vm.minutesInBed !== vm.absoluteMinimumMinutesInBed || vm.recommendedMinutesInBed - vm.errorMinutes === vm.absoluteMinimumMinutesInBed) && vm.minutesInBed <= vm.minimumMinutesInBed;
    };

    // this is the softest and therefore least relevant warning
    vm.showScheduleWarning = function () {
      return vm.isScheduleWarning() && !vm.showAtMinimumWarning() && !vm.isScheduleError() && !vm.noticeClosed;
    };

    // minimum warning takes priority over the schedule warning.  it warns but hard-stops at the lower threshold
    vm.showAtMinimumWarning = function () {
      return !vm.isScheduleError() && vm.minutesInBed === vm.minimumMinutesInBed && !vm.noticeClosed;
    };

    /// the error takes priority over both warnings and does not allow progress
    vm.showScheduleError = function () {
      return vm.isScheduleError() && !vm.noticeClosed;
    };

    // this is used to control the messaging for the minimum allowed time in bed
    vm.isBelowMinimumThreshold = function () {
      return vm.averageMinutesAsleep < vm.schedule.minimumMinutesAsleep;
    };

    vm.isValidInBedTimeChange = function (amount) {
      return sleepScheduleSvc.isValidInBedTimeChange(amount, vm.minutesInBed, vm.minimumMinutesInBed, vm.maximumMinutesInBed);
    };

    vm.isValidWakeUpTimeChange = function (amount) {
      return sleepScheduleSvc.isValidWakeUpTimeChange(amount, vm.minutesInBed, vm.minimumMinutesInBed, vm.maximumMinutesInBed);
    };

    vm.$onInit = function () {
      $log.debug('InitialSleepSchedule activate');
      if (!vm.schedule) {
        throw new Error('Schedule was not set');
      }

      vm.average = vm.schedule.averages;
      vm.averageMinutesAsleep = vm.average.minutesAsleep;

      // this is the editable variable
      vm.minutesInBed = vm.schedule.recommendedMinutesInBed;
      vm.absoluteMinimumMinutesInBed = vm.schedule.minimumMinutesAsleep + vm.sleepBuffer;
      vm.minimumMinutesInBed = Math.max(vm.absoluteMinimumMinutesInBed, vm.schedule.recommendedMinutesInBed - vm.errorMinutes);

      // this variable is used to abstract the recommended minimum.
      // if their average is less than the server-defined minimum, use the minimum.
      vm.recommendedMinutesInBed = Math.max(vm.minimumMinutesInBed, vm.minutesInBed);

      vm.schedule.inBedTime = moment(vm.schedule.recommendedInBedTime[0] + ":" + vm.schedule.recommendedInBedTime[1], "HH:mm");
      vm.schedule.wakeUpTime = moment(vm.schedule.averageOutOfBedTime[0] + ":" + vm.schedule.averageOutOfBedTime[1], "HH:mm");

      // make validation copies.
      vm.recommendedInBedTime = moment(vm.schedule.inBedTime);
      vm.recommendedWakeUpTime = moment(vm.schedule.wakeUpTime);
      vm.maximumMinutesInBed = vm.recommendedMinutesInBed + vm.errorMinutes;
    };
  }
})();